export const FORWARD_TENOR_ORDER = [
  "ON",
  "TN",
  "SN",
  "1D",
  "2D",
  "3D",
  "1W",
  "2W",
  "3W",
  "1M",
  "2M",
  "3M",
  "4M",
  "5M",
  "6M",
  "7M",
  "8M",
  "9M",
  "10M",
  "11M",
  "1Y",
];

const FORWARD_TENOR_SET = new Set(FORWARD_TENOR_ORDER);

const FORWARD_TENOR_ALIASES = new Map([
  ["ON", "ON"],
  ["OVERNIGHT", "ON"],
  ["ONIGHT", "ON"],
  ["O/N", "ON"],
  ["TN", "TN"],
  ["TOMNEXT", "TN"],
  ["TOMORROWNEXT", "TN"],
  ["T/N", "TN"],
  ["SN", "SN"],
  ["SPOTNEXT", "SN"],
  ["SPOTNXT", "SN"],
  ["S/N", "SN"],
]);

const MONTH_TO_YEAR_EQUIVALENTS = new Map([
  [12, "1Y"],
]);

const TENOR_UNIT_ALIASES = new Map([
  ["D", "D"],
  ["DAY", "D"],
  ["DAYS", "D"],
  ["W", "W"],
  ["WK", "W"],
  ["WKS", "W"],
  ["WEEK", "W"],
  ["WEEKS", "W"],
  ["M", "M"],
  ["MO", "M"],
  ["MOS", "M"],
  ["MON", "M"],
  ["MONTH", "M"],
  ["MONTHS", "M"],
  ["Y", "Y"],
  ["YR", "Y"],
  ["YRS", "Y"],
  ["YEAR", "Y"],
  ["YEARS", "Y"],
]);

const normalizeTenorToken = (value) =>
  String(value || "")
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "");

export const normalizeForwardTenor = (value) => {
  const normalizedValue = normalizeTenorToken(value);

  if (!normalizedValue) return null;

  if (FORWARD_TENOR_ALIASES.has(normalizedValue)) {
    return FORWARD_TENOR_ALIASES.get(normalizedValue);
  }

  if (FORWARD_TENOR_SET.has(normalizedValue)) {
    return normalizedValue;
  }

  const match = normalizedValue.match(/^(\d+)([A-Z]+)$/);
  if (!match) return null;

  const amount = Number(match[1]);
  const rawUnit = match[2];
  const unit = TENOR_UNIT_ALIASES.get(rawUnit);

  if (!Number.isInteger(amount) || amount <= 0 || !unit) {
    return null;
  }

  if (unit === "M" && MONTH_TO_YEAR_EQUIVALENTS.has(amount)) {
    return MONTH_TO_YEAR_EQUIVALENTS.get(amount);
  }

  const canonicalTenor = `${amount}${unit}`;
  return FORWARD_TENOR_SET.has(canonicalTenor) ? canonicalTenor : null;
};

export const getCanonicalForwardTenors = (tenors = []) => {
  const supportedTenors = new Set();

  (Array.isArray(tenors) ? tenors : []).forEach((tenor) => {
    const normalizedTenor = normalizeForwardTenor(tenor);
    if (normalizedTenor) {
      supportedTenors.add(normalizedTenor);
    }
  });

  return FORWARD_TENOR_ORDER.filter((tenor) => supportedTenors.has(tenor));
};

export const getCanonicalForwardPoints = (forwardPoints = []) => {
  const pointByTenor = new Map();

  (Array.isArray(forwardPoints) ? forwardPoints : []).forEach((item) => {
    const normalizedTenor = normalizeForwardTenor(item?.tenor);
    if (!normalizedTenor) return;

    pointByTenor.set(normalizedTenor, {
      ...item,
      tenor: normalizedTenor,
    });
  });

  return FORWARD_TENOR_ORDER.filter((tenor) => pointByTenor.has(tenor)).map(
    (tenor) => pointByTenor.get(tenor),
  );
};

export const filterForwardPointsByTenors = (forwardPoints = [], tenors = []) => {
  const canonicalForwardPoints = getCanonicalForwardPoints(forwardPoints);
  const selectedTenors = new Set(getCanonicalForwardTenors(tenors));

  if (selectedTenors.size === 0) {
    return canonicalForwardPoints;
  }

  return canonicalForwardPoints.filter((item) => selectedTenors.has(item.tenor));
};
